import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface GuardrailDto {
  id: string;
  documentId: string;
  documentName: string | null;
  policyName: string | null;
  ruleType: string;
  condition: string;
  sourceClause: string;
  pageReference: string | null;
  confidence: number;
  chunkId: string | null;
  documentIdExternal: string | null;
  normalizedStatement: string | null;
  provenanceVerdict: string | null;
  classification: string | null;
  subClassification: string | null;
  status: string | null;
  createdAt: string;
  reviewedBy: string | null;
  reviewedAt: string | null;
  reviewNotes: string | null;
}

export interface GuardrailListResponse {
  statusCode: number;
  success: boolean;
  message: string;
  data: {
    total: number;
    page: number;
    pageSize: number;
    items: GuardrailDto[];
    auditEventsCount: number;
    declinedCount: number;
  };
}

export interface GuardrailResponse {
  statusCode: number;
  success: boolean;
  message: string;
  data: GuardrailDto;
}

export interface GuardrailStatsDto {
  total: number;
  needsReviewCount: number;
  approvedCount: number;
  declinedCount: number;
  averageConfidence: number;
}

export interface GuardrailStatsResponse {
  statusCode: number;
  success: boolean;
  message: string;
  data: GuardrailStatsDto;
}

@Injectable({
  providedIn: 'root'
})
export class Guardrails {
  private baseUrl = `${environment.apiUrl}/guardrails`;

  constructor(private http: HttpClient) {}

  readGuardrails(page = 1, pageSize = 200, status?: string): Observable<GuardrailListResponse> {
    const statusParam = status ? `&status=${encodeURIComponent(status)}` : '';
    return this.http.get<GuardrailListResponse>(`${this.baseUrl}?page=${page}&pageSize=${pageSize}${statusParam}`);
  }

  getStats(): Observable<GuardrailStatsResponse> {
    return this.http.get<GuardrailStatsResponse>(`${this.baseUrl}/stats`);
  }

  approveGuardrail(id: string): Observable<GuardrailResponse> {
    return this.http.post<GuardrailResponse>(`${this.baseUrl}/${id}/approve`, {});
  }

  declineGuardrail(id: string): Observable<GuardrailResponse> {
    return this.http.post<GuardrailResponse>(`${this.baseUrl}/${id}/decline`, {});
  }
}
